<style>

.info-box{
  display: grid;
  grid-template-columns: 45px auto 32px;
  background-color: white;
  color: black;
  border-radius: 5px;
  margin-bottom: 5px;
  padding: 10px 3px 9px 3px;
  align-items: center;
}
.light{
  background-color: inherit;
  color: inherit;
}
.info-box-icon{
  grid-column: 1;
  text-align: center;
}
.info-box-text{
  grid-column: 2;
  font-size: 19px;
  margin-left: 10px;
}
.info-box-arrow{
  grid-column: 3;
}
[class^="icon-"] {
  font-size: 30px;
  color: #696969;
}
.light-icon{
  color: white;
}

</style>

<div class="info-box {theme == 'light' ? 'light' : ''}" on:click="{ () => { dispatch(callback) } }">
  <div class="info-box-icon"> <i class="{actualIcon} {theme == 'light' ? 'light-icon' : ''}"></i> </div>
  <div class="info-box-text"><slot></slot></div>
  {#if arrows}
    <div class="info-box-arrow"> <i class="icon-arrow_right {theme == 'light' ? 'light-icon' : ''}"></i> </div>
  {/if}
</div>


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let icon = "website";
export let callback = "infoBoxClicked";
export let theme = "dark";
export let arrows = true;

let actualIcon = "";

$: {
  // translate icon text into actual icon
  if (icon) {
    if (icon == "website") actualIcon = "icon-globe";
    if (icon == "address") actualIcon = "icon-location_on";
    if (icon == "phone") actualIcon = "icon-call";
    if (icon == "price") actualIcon = "icon-attach_money";
    if (icon == "facebook") actualIcon = "icon-facebook";
    if (icon == "instagram") actualIcon = "icon-instagram";
    if (icon == "linkedin") actualIcon = "icon-linkedin";
    if (icon == "snapchat") actualIcon = "icon-snapchat";
    if (icon == "twitter") actualIcon = "icon-twitter";
  }
}

</script>